import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const isMobile = () => window.innerWidth <= 768;

const DesktopIcon = ({ Icon, label, onDoubleClick, style }) => {
  const clickTimeout = useRef(null);
  const clickCount = useRef(0);
  const [mobile, setMobile] = useState(isMobile);

  useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClick = () => {
    // On mobile, single tap opens the window
    if (mobile) {
      onDoubleClick();
      return;
    }

    // On desktop, require double-click
    clickCount.current += 1;

    if (clickCount.current === 1) {
      clickTimeout.current = setTimeout(() => {
        clickCount.current = 0;
      }, 300);
    } else if (clickCount.current === 2) {
      clearTimeout(clickTimeout.current);
      clickCount.current = 0;
      onDoubleClick();
    }
  };

  return (
    <motion.div
      className="desktop-icon"
      style={mobile ? {} : { ...style, touchAction: 'none' }}
      onClick={handleClick}
      drag={!mobile}
      dragMomentum={false}
      whileHover={mobile ? {} : { scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      role="button"
      aria-label={`Open ${label}`}
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onDoubleClick()}
    >
      <motion.div
        className="icon-glow"
        animate={{
          opacity: [0.3, 0.6, 0.3],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
          delay: Math.random() * 2
        }}
      />
      <div className="icon-image">
        <Icon size={32} strokeWidth={1.5} />
      </div>
      <span className="icon-label">{label}</span>
    </motion.div>
  );
};

export default DesktopIcon;
